// extracted by mini-css-extract-plugin
export default {"sectionTitle":"BundleSellingPoints-sectionTitle","parentWrap":"BundleSellingPoints-parentWrap","itemWrap":"BundleSellingPoints-itemWrap"};